<template>
    <article>
        <h1>{{ $dictionary.get(conditionsHeaderLabel) }}</h1>
        <BlockList :blocks="contentBlocks"
                   class="mt-10 sm:mt-20"/>
    </article>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { HeadlessJsonContent } from '@/types/contentServerContract';
import { IModal } from '@/core/modals/ModalState';
import BlockList from '@/project/app/blocks/helpers/BlockList.vue';

const props = defineProps({
    modal: {
        type: Object as PropType<IModal>,
        required: true
    },
    conditionsHeaderLabel: {
        type: String,
        required: true,
    },
    contentBlocks: {
        type: Array as PropType<HeadlessJsonContent[]>,
        required: true,
    }
});
</script>
